/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/recurring_run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Reference to an existing pipeline version.
 * @export
 * @interface V2beta1PipelineVersionReference
 */
export interface V2beta1PipelineVersionReference {
  /**
   * Input. Required. Unique ID of the parent pipeline.
   * @type {string}
   * @memberof V2beta1PipelineVersionReference
   */
  pipeline_id?: string;
  /**
   * Input. Optional. Unique ID of an existing pipeline version. If unset, the latest pipeline version is used.
   * @type {string}
   * @memberof V2beta1PipelineVersionReference
   */
  pipeline_version_id?: string;
}

/**
 * Check if a given object implements the V2beta1PipelineVersionReference interface.
 */
export function instanceOfV2beta1PipelineVersionReference(
  value: object,
): value is V2beta1PipelineVersionReference {
  return true;
}

export function V2beta1PipelineVersionReferenceFromJSON(
  json: any,
): V2beta1PipelineVersionReference {
  return V2beta1PipelineVersionReferenceFromJSONTyped(json, false);
}

export function V2beta1PipelineVersionReferenceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1PipelineVersionReference {
  if (json == null) {
    return json;
  }
  return {
    pipeline_id: json['pipeline_id'] == null ? undefined : json['pipeline_id'],
    pipeline_version_id:
      json['pipeline_version_id'] == null ? undefined : json['pipeline_version_id'],
  };
}

export function V2beta1PipelineVersionReferenceToJSON(json: any): V2beta1PipelineVersionReference {
  return V2beta1PipelineVersionReferenceToJSONTyped(json, false);
}

export function V2beta1PipelineVersionReferenceToJSONTyped(
  value?: V2beta1PipelineVersionReference | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    pipeline_id: value['pipeline_id'],
    pipeline_version_id: value['pipeline_version_id'],
  };
}
